import { State } from 'redux/utils/Form'

export default State()